var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKaren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 104",
    style: {
      enableBackground: "new 0 0 136 104"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#E8C2A5;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1F170C;}\r\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Head_x2F_Front_x2F_Wavy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(54.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2,23c-4.5-5.3-7.6-11.9-7.1-19.2c1.5-21.1,30.9-16.5,36.6-5.8c5.7,10.6,5.1,37.7-2.3,39.6 c-3,0.8-9.2-1.1-15.6-4.9l4,28.4H12L20.2,23z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    className: "st1",
    d: "M105.9,33.8c-0.2-1.4-0.8-2.9-1.2-4.2c-0.6-1.7-1.5-3.2-2.5-4.6c-1.9-2.7-4.1-5.1-6.6-7.2 c-4.5-3.7-10.3-5.8-15.9-5.1c-2.9,0.3-5.6,1.4-8,3.3c-2.1,1.6-4.2,4.1-6.9,4.2c-3,0.2-5.8-2.5-8.2-4.1c-2.8-1.9-5.7-3.2-8.8-3.7 c-5.4-0.9-10.4,0.9-14,5.3C29.8,22.2,27,29,29.5,35.2c0.5,1.2,1.1,2.1,1.9,2.9c0.8,0.7,2,1.5,2.3,2.7c0.3,1.2-0.7,2.9-1.1,4 c-0.5,1.6-1,3.3-0.9,5.1c0.3,2.9,2.1,5.6,4,7.5c1.9,1.9,4.4,3,6.9,3.5c1.7,0.3,3.4,0.5,5.1,0.4c0.9-0.1,1.6-0.3,2.4-0.5 s1.2,0,1.9,0.5c3.2,2,6.6,2.9,10.3,2.6c3.1-0.2,6.7-1,9.2-3.1c2.8-2.3,2.7-5.6,2.1-9.1c0.7,0.3,2.7,0.5,1.5-0.9 c-0.5-0.5-1.3-0.8-1.9-1.1c-0.7-0.4-1.4-0.9-1.9-1.5c-2.2-2.5,0-7.6,2.7-8.3c4.1-1.2,4.9,4.4,7.8,5.9c1.6,0.9,3.4-0.3,4.6-1.5 c1.6-1.6,2.8-3.7,3.7-5.8c0.8-1.8,1.6-3.5,2.3-5.3c0.4-0.8,1.7-3.1,1-4.1c2.9-0.5,6.1,0.6,8.6,2.2c1,0.6,1.8,1.4,2.3,2.5 c0.2,0.2,0.4,1,0.7,1C106.2,34.8,106,34.1,105.9,33.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaren);
export default __webpack_public_path__ + "static/media/Karen.6d802369f8236b8b42829878a0f7489c.svg";
export { ForwardRef as ReactComponent };